import React from 'react';
import { Box, Typography, IconButton, Tooltip, Avatar } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import GroupAddIcon from '@mui/icons-material/GroupAdd';
import OpenInFullIcon from '@mui/icons-material/OpenInFull';
import PresenceStatusSelector from './PresenceStatusSelector';
import { MSN } from './msnTheme';
import { getAuthenticatedUploadUrl } from '../../api/client';

const STATUS_COLOR = MSN.statusBorder || {
  available: MSN.online,
  busy: MSN.busy,
  away: MSN.away,
  offline: MSN.offline
};

/**
 * Header do painel — corporativo limpo.
 * FASE 2: botão expandir Dual-Pane.
 */
export default function ChatHeader({
  status,
  setStatus,
  connected,
  onClose,
  onNewGroup,
  onExpand,
  user,
  fotoPerfil,
  hideClose = false
}) {
  return (
    <Box
      sx={{
        bgcolor: 'background.paper',
        px: 2,
        py: 1.5,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        borderBottom: '1px solid',
        borderColor: 'divider',
        flexShrink: 0
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, minWidth: 0 }}>
        <Box sx={{ position: 'relative', flexShrink: 0 }}>
          <Avatar
            src={fotoPerfil ? getAuthenticatedUploadUrl(fotoPerfil) : undefined}
            sx={{
              width: 40,
              height: 40,
              bgcolor: 'primary.main',
              color: '#fff',
              fontSize: 16
            }}
          >
            {!fotoPerfil && (user?.nome || user?.email || '?').charAt(0).toUpperCase()}
          </Avatar>
          <Box
            sx={{
              position: 'absolute',
              bottom: 0,
              right: 0,
              width: 12,
              height: 12,
              borderRadius: '50%',
              bgcolor: STATUS_COLOR[status] || STATUS_COLOR.offline,
              border: '2px solid',
              borderColor: 'background.paper'
            }}
            aria-hidden
          />
        </Box>
        <Box sx={{ minWidth: 0 }}>
          <Typography sx={{ fontWeight: 700, fontSize: 14, color: 'text.primary' }} noWrap>
            {user?.nome || user?.email || 'Usuário'}
          </Typography>
          <Typography sx={{ fontSize: 12, color: 'text.secondary' }}>
            {connected ? 'Online' : 'Desconectado'}
          </Typography>
        </Box>
        <PresenceStatusSelector status={status} setStatus={setStatus} />
      </Box>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, flexShrink: 0 }}>
        {onNewGroup && (
          <Tooltip title="Novo grupo">
            <IconButton size="small" onClick={onNewGroup} aria-label="Novo grupo">
              <GroupAddIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        )}
        {onExpand && (
          <Tooltip title="Centro de comunicações">
            <IconButton size="small" onClick={onExpand} aria-label="Expandir chat">
              <OpenInFullIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        )}
        {!hideClose && (
          <IconButton
            size="small"
            onClick={onClose}
            aria-label="Fechar chat"
            onKeyDown={(e) => e.key === 'Enter' && onClose()}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        )}
      </Box>
    </Box>
  );
}
